<!-- 项目 -->
<template>
  <div class="app-container">
    <el-card class="box-card">
      <!-- 搜索-->
      <dynamic-search :data="tableFilterList(tableHead)" @search="dataTableSearch">
        <template v-slot:next>
          <el-button icon="el-icon-plus" @click="add()">新增</el-button>
          <el-popover placement="bottom" trigger="click">
            <label style="color:red;font-size: 0.75rem;">
              温馨提示：若项目计划已经存在，再次导入会根据项目号+节点编号进行覆盖更新
            </label>
            <el-upload
              class="upload-demo"
              ref="upload"
              action=""
              :before-upload="beforeUpload"
              :show-file-list="true"
              :file-list="fileList"
              accept=".xlsx,.xls"
              :limit="1"
              :auto-upload="false">

              <el-button slot="trigger" size="mini" type="" class="el-button--warning link-left">选取文件</el-button>
              <el-button @click="submitUpload" type="primary" size="mini" :loading="uploadLoading" class=" link-left">导入</el-button>
              <el-button size="mini" class="el-button--goon" @click="downTemplate">下载导入模版
                <!-- <a href="static/template.xls" download="template.xls">下载导入模版</a> -->
              </el-button>
            </el-upload>
            <el-button slot="reference" style="margin-left:10px;" icon="el-icon-upload2" type="primary">导入</el-button>
          </el-popover>
        </template>
      </dynamic-search>
      <edit-data-table
        :head="tableHead"
        :data.sync="list"
        :edit-rules="validRules"
        :config="{trigger: 'click', mode: 'cell'}"
        :total="total"
        :offset="offset"
        :page="page"
        :loading="loading"
        stripe
        @handlePageChange="dataTablePageChange"
        @handleSizeChange="dataTableSizeChange"
      >
        <template #status="{row}">
          <el-switch v-model="row.status" active-color="#13ce66" inactive-color="#999" :active-value="0" :inactive-value="1" @change="changeStageState(row)" />
        </template>
        <template #toolbar="scope">
          <el-button
            type="text"
            icon="el-icon-view"
            style="color:#4084B7;"
            @click="look(scope.row)"
          />
          <el-button
            type="text"
            size="mini"
            icon="el-icon-edit"
            style="color:#4084B7"
            @click="edit(scope.row)"
          ></el-button>
          <el-popover :ref="scope.row.id" placement="top" width="180">
            <p>确定删除本条数据吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="$refs[scope.row.id].doClose()">取消</el-button>
              <el-button
                :loading="delLoading"
                type="primary"
                size="mini"
                @click="subDelete(scope.row.id)"
              >确定</el-button>
            </div>
            <el-button
              type="text"
              size="mini"
              icon="el-icon-delete"
              slot="reference"
            ></el-button>
          </el-popover>
        </template>
      </edit-data-table>
    </el-card>
    <drag-dialog
      append-to-body
      :show.sync="dialogVisible"
      title="商机新增"
      :enableDrag="true"
      width="500px"
      @close="cancel"
    >
      <dynamic-form
        :formConfig="formConfig"
        labelWidth="120px"
        v-model="form"
        @submit="submit"
        @cancelForm="cancel"
        :disabled="!isEdit"
        ref="pageForm"
      ></dynamic-form>
    </drag-dialog>
  </div>
</template>

<script>
import "@/components/EditDataTable";
import DynamicSearch from "@/components/DynamicSearch";
import DataTableMixin from "@/mixins/DataTableMixin";
import "@/components/dynamic-form";
import DragDialog from "@/components/DragDialog";
import { addSave, deleteProject, importExcel, exportFilePost, changeStatus } from "@/api/sale/index"
export default {
  name: "OpportunityIndex",
  directives: {},
  filters: {},
  mixins: [DataTableMixin],
  props: {},
  components: {
    DynamicSearch,
    DragDialog
  },
  data() {
    return {
      uploadLoading: false,
      fileList: [],
      delLoading: false,
      form: {},
      isEdit: true,
      openLook: false,
      dialogVisible: false,
      tableHead: [
        {
          prop: "businessNumber",
          label: "商机编号",
          query: {
            type: "input"
          }
        },
        {
          prop: "businessName",
          label: "商机名称",
          query: {
            type: "input"
          }
        },
        {
          prop: "businessStage",
          label: "商机阶段",
        },
        {
          prop: "productType",
          label: "产品类型",
        },
        {
          prop: "terminalHolder",
          label: "销售机会所有人",
          query: {
            type: "input"
          }
        },
        {
          prop: "terminalCustomerName",
          label: "终端客户名称",
          query: {
            type: "input"
          }
        },
        {
          prop: "status",
          label: "商机状态",
          query: {
            type: "select",
            value: '0',
            data: [{ label: '启用', value: '0' }, { label: '禁用', value: '1' }]
          }
        }
      ],
      formConfig: {
        formItemList: [
          {
            type: "input",
            key: "businessNumber",
            maxlength: "50",
            label: "商机编号",
            value: "",
            rules: [
              {
                required: true,
                message: "商机编号不能为空",
                trigger: "blur"
              },
              {
                pattern: "^[^\u4e00-\u9fa5]{0,}$",
                message: "商机编号不能含有中文",
                trigger: "blur"
              },
            ]
          },
          {
            type: "input",
            key: "businessName",
            maxlength: "100",
            label: "商机名称",
          },
          {
            label: "商机阶段",
            key: "businessStage",
            type: "input"
          },
          {
            label: "产品类型",
            key: "productType",
            type: "input"
          },
          {
            label: "销售机会所有人",
            key: "terminalHolder",
            type: "input"
          },
          {
            label: "终端客户名称",
            key: "terminalCustomerName",
            type: "input"
          }
        ]
      },
      validRules: {
        code: [{ required: true, message: "请输入键值", trigger: "blur" }],
        name: [{ required: true, message: "请输入项目名称", trigger: "blur" }],
        customer: [{ required: true, message: "客户不能为空", trigger: "blur" }]
      }
    };
  },
  computed: {},
  watch: {},
  created() {
    // 列表数据初始化
    this.$nextTick(() => {
      // console.log(1);
      this.dataTableInit();
    });
  },
  methods: {
    // 当发生改变时
    changeStageState(row) {
      /* debugger
      if (row.stageState === 0) {
        row.stageState = 1
      } else {
        row.stageState = 0
      } */
      this.form = row;
      // this.submit()
      changeStatus({ status: row.stageState }, this.form.id).then(res => {
        this.$notify({ title: "操作成功！", type: "success", duration: 2500 });
        this.dataTableInit();
      })
    },
    // 打开添加弹框
    add() {
      this.form = {};
      this.isEdit = true
      this.dialogVisible = true;
    },
    // 取消关闭弹框
    cancel() {
      this.dialogVisible = false;
    },
    // 修改
    edit(row) {
      this.form = row;
      this.isEdit = true
      this.dialogVisible = true;
    },
    look(row) {
      this.form = row;
      this.isEdit = false
      this.dialogVisible = true;
    },
    // 提交 （添加/修改）
    submit() {
      addSave(this.form).then(res => {
        this.$notify({ title: "操作成功！", type: "success", duration: 2500 });
        this.dataTableInit();
        this.cancel();
      })
    },
    editActiveEvent(row, column) {
      console.log(row, column);
    },
    // 表格数据接口参数设置
    dataTableBeforeInit() {
      this._url = `/businessManage/getList`;
      const params = { page: this.page, size: this.offset, status: 0 };
      this._params = Object.assign(params, this._query);
      return true;
    },
    // 删除数据
    handleDeletes(rows) {
      rows.forEach(element => {
        this.subDelete(element.id);
      });
    },
    // 删除数据
    subDelete(id) {
      this.delLoading = true;
      deleteProject(id).then(res => {
        this.delLoading = false;
        this.$refs[id].doClose();
        this.dleTableChangePage();
        this.dataTableInit();
        this.$notify({
          title: "删除成功",
          type: "success",
          duration: 2500
        });
      }).catch(err => {
        this.delLoading = false;
        this.$refs[id].doClose();
        console.log(err);
      });
    },
    downTemplate() {
      exportFilePost(`/businessManage/expExcelTemp`, '销售机会管理模板.xls')
    },
    // 导入
    submitUpload() {
      this.uploadLoading = true;
      const that = this
      setTimeout(function() {
        if (that.$refs.upload.$children[0].fileList.length === 1) {
          that.$refs.upload.submit();
        } else {
          that.uploadLoading = false;
          that.$message({
            type: 'error',
            showClose: true,
            duration: 3000,
            message: '请选择文件后，在进行导入哦!'
          });
        }
      },100);
    },
    // 导入方法
    beforeUpload(file) {
      const that = this
      // 文件类型
      const fileName = file.name.substring(file.name.lastIndexOf('.') + 1)
      if (fileName !== 'xls' && fileName !== 'xlsx') {
        that.uploadLoading = false;
        that.$message({
          type: 'error',
          showClose: true,
          duration: 3000,
          message: '文件类型不是.xls'
        });
        return false;
      }
      that.downloadLoading = that.$loading({
        lock: true,
        text: '数据导入中...,请稍后',
        spinner: 'el-icon-loading',
        background: 'rgba(0,0,0,0.7)'
      });
      const fd = new FormData();
      fd.append('file',file);
      fd.append('_t1',new Date());
      importExcel(fd).then(resp => {
        console.log(resp);
        that.downloadLoading.close();
        that.uploadLoading = false;
        if (resp.code === 200) {
          that.uploadTemplateDialog = false;
          that.$message.success(resp.msg);
          // location.reload();
          this.dataTableInit();
        } else {
          that.uploadTemplateDialog = false;
          that.$message({
            type: 'error',
            showClose: true,
            duration: 60000,
            message: resp.msg
          });
        }
      })
    },
  }
};
</script>

<style lang="scss" scoped>
::v-deep {
  .el-upload-list__item {
    width: 100%;
  }
}
</style>